/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PartialSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {Resource} from "../../api/resource";
import {TransportistaTipoEnvioRel} from "./transportista-tipo-envio-rel.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {ManagerCachingStrategy} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {IRI_PROPERTY, TYPE_PROPERTY} from "../../basic-entity-back/basic-entity-interface/mapping-internal";

@BasicEntity({
    name: 'Prioridad de envío',
    endpoint: 'prioridad_envios',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'nombre',
    type: 'PrioridadEnvio',
    managerCaching: ManagerCachingStrategy.Lazy
})
export class PrioridadEnvio extends Resource {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    @BasicProperty({
        name: 'Nombre',
        type: PropertyType.String(),
        sortable: true,
        nullable: true,
        order: 2,
        filters: [PartialSearchFilter]
    })
    private _nombre;

    @BasicProperty({
        name: 'Transportista - Tipo envío',
        type: PropertyType.NestedModel(TransportistaTipoEnvioRel, null, NestedBehavior.CreateOnly, [TYPE_PROPERTY, IRI_PROPERTY, 'prioridadEnvio']),
        array: true,
        order: 3
    })
    private _tiposEnvioTransportista;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get nombre() {
        return this._nombre;
    }

    set nombre(value) {
        this._nombre = value;
    }

    get tiposEnvioTransportista() {
        return this._tiposEnvioTransportista;
    }

    set tiposEnvioTransportista(value) {
        this._tiposEnvioTransportista = value;
    }
}

TransportistaTipoEnvioRel.MAP_PRIORIDAD_ENVIO.type = PropertyType.Uri(PrioridadEnvio)
